module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_vm._m(0), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "isotopeGrid"
  }, [_c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          寵物家居安全\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          如何令您的寵物遠離危險\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/pets.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt_group"
  }, [_c('h1', [_vm._v("寵物家居安全")]), _vm._v(" "), _c('p', [_vm._v("在家中使用任何類型的殺蟲產品時，產品安全是最為重要的考慮因素，尤其是家中有飼養寵物的用家。威滅產品是專門為針對曱甴和螞蟻而設計，對寵物來說只有極微量毒性。少量的藥餌對寵物的影響不大，但仍然建議採取一些預防措施來保護您家居的寵物。")])]), _vm._v(" "), _c('div', {
    staticClass: "txt_group"
  }, [_c('h1', {
    staticClass: "clear"
  }, [_vm._v("4個寵物安全小貼士")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("使用前必須閱讀及遵照標籤指示，不要超過建議使用量。")]), _vm._v(" "), _c('li', [_vm._v("請將藥餌遠離寵物籠、食物或水碗，避免寵物觸及。")]), _vm._v(" "), _c('li', [_vm._v("請保持藥餌盒完整，不要強行打開餌盒。")]), _vm._v(" "), _c('li', [_vm._v("請放置藥餌盒於孩童及寵物不能觸及的地方。")])])]), _vm._v(" "), _c('div', {
    staticClass: "txt_group"
  }, [_c('p', [_vm._v("如對於產品有任何疑問，請致電查詢熱線：2895 9515")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6ef37d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PTipsPetSafety.vue
// module id = 247
// module chunks = 0